import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkCouponUploadActions from "../../store/actions/BulkCouponUpload";
import { Container } from "@material-ui/core";
import { useState } from "react";
import RainReportingModal from "../../components/RainReporting/RainReportingModal";
const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const RainReporting = () => {
  const [modalState, setModalState] = useState(true);
  const handleClose = () => {
    setModalState(false);
  };
  return (
    <div>
      {modalState && <RainReportingModal handleModalClose={handleClose} />}
    </div>
  );
};

export default RainReporting;
